<h2 mat-dialog-title class="fb-title">
  <span class="fb-title-icon"><mat-icon>rate_review</mat-icon></span>
  <span class="fb-title-text">
    Share Feedback
    <small>Help us make the app better</small>
  </span>
</h2>

<mat-dialog-content class="fb-content">

  <!-- Feedback type selector -->
  <div class="fb-block">
    <div class="fb-block-label">What kind of feedback is this?</div>
    <div class="fb-type-grid">
      @for (t of feedbackTypes; track t.value) {
        <button type="button" class="fb-type-card"
                [class.selected]="feedbackType === t.value"
                [style.--fb-type-color]="t.color"
                [matTooltip]="t.description" matTooltipPosition="above"
                (click)="feedbackType = t.value">
          <mat-icon>{{ t.icon }}</mat-icon>
          <span>{{ t.label }}</span>
        </button>
      }
    </div>
  </div>

  <!-- Feature area -->
  <mat-form-field appearance="outline" class="fb-full">
    <mat-label>Feature area</mat-label>
    <mat-select [(ngModel)]="feature">
      @for (f of features; track f) {
        <mat-option [value]="f">{{ f }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Rating -->
  <div class="fb-block">
    <div class="fb-block-label">
      Rating <span class="fb-optional">optional</span>
    </div>
    <div class="fb-stars">
      @for (star of [1,2,3,4,5]; track star) {
        <button type="button" class="fb-star" (click)="setRating(star)"
                [class.filled]="star <= rating"
                [matTooltip]="star + '/5'" matTooltipPosition="above">
          <mat-icon>{{ star <= rating ? 'star' : 'star_border' }}</mat-icon>
        </button>
      }
      @if (rating > 0) {
        <span class="fb-rating-value">{{ rating }}/5</span>
      }
    </div>
  </div>

  <!-- Comment -->
  <mat-form-field appearance="outline" class="fb-full">
    <mat-label>Comment</mat-label>
    <textarea matInput [(ngModel)]="comment" rows="3"
              placeholder="Describe what you experienced or what could be improved…"></textarea>
  </mat-form-field>

  <!-- Screenshot -->
  <div class="fb-block">
    <div class="fb-block-label">
      Screenshot <span class="fb-optional">optional</span>
    </div>
    @if (!previewUrl) {
      <label class="fb-dropzone">
        <mat-icon>add_photo_alternate</mat-icon>
        <span class="fb-dropzone-main">Click to attach a screenshot</span>
        <span class="fb-dropzone-sub">PNG or JPG</span>
        <input type="file" accept="image/*" (change)="onFileSelected($event)" hidden />
      </label>
    } @else {
      <div class="fb-preview">
        <img [src]="previewUrl" alt="Screenshot preview" />
        <button type="button" class="fb-preview-remove" (click)="removeFile()"
                matTooltip="Remove">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  </div>

  <!-- Anonymous -->
  <div class="fb-anon">
    <mat-slide-toggle [(ngModel)]="isAnonymous" color="primary">
      <span class="fb-anon-label">Submit anonymously</span>
    </mat-slide-toggle>
    @if (isAnonymous) {
      <p class="fb-anon-note">
        <mat-icon>visibility_off</mat-icon>
        Your identity won't be recorded with this feedback.
      </p>
    }
  </div>

</mat-dialog-content>

<mat-dialog-actions class="fb-actions">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary"
          [disabled]="!isValid || submitting()" (click)="submit()">
    @if (submitting()) {
      <mat-spinner diameter="18"></mat-spinner>
    } @else {
      <ng-container>
        <mat-icon>send</mat-icon>
        Submit Feedback
      </ng-container>
    }
  </button>
</mat-dialog-actions>
